import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';
import { GroupMasterService } from 'src/app/services/group-master.service';
import { ProcessMasterService } from 'src/app/services/process-master.service';
import { TaskService } from 'src/app/services/task.service';
import { AlertComponent } from '../../alert/alert.component';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { AuthAlertComponent } from '../../auth-alert/auth-alert.component';
import { environment } from 'src/environments/environment';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { LoaderService } from 'src/app/services/loader.service';
@Component({
  selector: 'app-add-new-process',
  templateUrl: './add-new-process.component.html',
  styleUrls: ['./add-new-process.component.css']
})
export class AddNewProcessComponent implements OnInit {

  public environmentSettings: any;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  dtOptionsTaskAddingPopup: DataTables.Settings = {};
  dtTriggerTaskAddingPopup: Subject<any> = new Subject();

  //dtOptionsForAddedTask: DataTables.Settings = {};
  dtOptionsForAddedTask: any = {};
  dtTriggerForAddedTask: Subject<any> = new Subject();

  // dtOptionsforProcessTasks: DataTables.Settings = {};
  // dtTriggerforProcessTasks: Subject<any> = new Subject();

  processMasterForm: FormGroup;
  processes: any[];
  meetingTypes: any[];
  processId: string;
  meetingtypeIdmodel: string;
  meetingType: string;
  isMeetingTask: boolean;
  processTaskId: string;
  processType: string;
  processtasklist: any[];
  SearchprocessUserdefinedorPredefinedModel: any;
  error: any = { isError: false, errorMessage: '' };


  preDefinedTask: any[];
  preDefinedTasknew: any[];
  currentURL: any;
  isClickedOnce = false;
  agendaId: any;

  selectedAll: any;
  IsSelectedTasks: any;
  companytasklist: any[];

  predefinedCompanyTaskList: any[];

  groupTypes: any[];
  groupID: any;
  SearchtaskEventbasedorPeriodicModel: any;
  SearchtaskUserdefinedorPredefinedModel: any;

  dataAdd: boolean = false;
  taskaddedforactivateProcess: boolean = false;
  ActualDataToProcess: any[];
  orderDetails: any;
  PageTitle: any;
  taskParticularsmodel: any;
  hasPermission: boolean;
  searcheFilteredDataTask: any[];
  disabledOnclick: boolean = false;
  isTaskGlobal: boolean;
  processCompanyId: any;

  disableOnEdit = false;
  meetingTypeName: any;
  isGlobalSelected: boolean = false;
  meetingTypeIdWhileEdit: any;

  constructor(private processMasterService: ProcessMasterService,
    private taskService: TaskService,
    private groupMasterService: GroupMasterService,
    private alert: AlertComponent,
    private commonFunction: CommonFunction,
    private router: Router,
    private location: Location,
    private loaderService: LoaderService,
    private activatedRoute: ActivatedRoute,
    private customValidation: CustomValidation,
    private meetingService: MeetingMasterService,
    private authAlert: AuthAlertComponent,
    private route: ActivatedRoute) {
    this.currentURL = window.location.href;

  }

  ngOnInit() {
    this.loaderService.disable();
    this.environmentSettings = environment;

    this.processMasterForm = new FormGroup({
      ProcessName: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      IsGlobal: new FormControl('', [Validators.required],),
      meetingtypeId: new FormControl('', []),
      TaskParticulars: new FormControl('', [])
    });

    if (this.currentURL.includes('edit')) {

      this.activatedRoute.params.subscribe(params => {
        if (params['processId'] != undefined) {
          this.processId = params['processId'];
          this.loadProcessToEdit(this.processId);
          this.showProcessTasks(this.processId);
        }
      });


      $("#myModalLabel").html('Update Process');
      $('#btnsaveProcess').hide();
      $('#btnshowtaskparticulars').hide();
      $('#btnupdateProcess').show();
      $('#buttonreset').hide();
      $('#btnsaveandActivateTask').hide();
      $('#btnshowtaskparticularsforupdateandactivate').show();
      $('#btnupdateandActivateTask').show();

    } else {

      // $("#myModalLabel").html('Process');
      this.PageTitle = "New Process";
      $('#btnsaveProcess').show();
      $('#btnupdateProcess').hide();
      $('#buttonreset').show();
      $('#btnshowtaskparticulars').show();
      $('#btnupdateandActivateTask').hide();
      $('#btnshowtaskparticularsforupdateandactivate').hide();
      $('#btnupdateandActivateTask').hide();
      this.processId = "";
      this.processMasterForm.controls.IsGlobal.setValue('Company');
      this.processMasterForm.controls.ProcessName.setValue('');
      this.isMeetingTask = false;
      this.meetingtypeIdmodel = '0';
      this.processMasterForm.controls.meetingtypeId.setValue(this.meetingtypeIdmodel);
    }



    //this.commonFunction.removeDataTableSaveStateKey("processTable");

    this.initialiseJqueryEvents();
    this.getMeetingTypeList();
    this.getpredefinedTaskList();
    this.getCompanyTaskList();
    this.getGroupmasterList();

    this.dtOptionsTaskAddingPopup = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [1, 'asc'],
      stateSave: true,
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [0] }],
    };

    this.dtOptionsForAddedTask = {
      destroy: true,
      scrollY: "250px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: false,
      //order: [1, 'asc'],
      stateSave: true,
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [3] }],
      //rowReorder:true
      rowReorder: {
        dataSrc: 'readingOrder',
        select: true,
      },
      select: true,
    };
    if (this.currentURL.includes('edit')) {
      hasEditPermission = this.commonFunction.validateURL('Process', 'edit');

      this.activatedRoute.params.subscribe(params => {
        console.log(JSON.parse(localStorage.getItem("companyDetails")).companyID);
        if (params['processId'] != undefined) {

          var data = {
            module: 'LibraryProcess',
            ID: params['processId'],
            CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
          }

          this.meetingService.authonticateDataForComapnay(data).subscribe(processAccess => {
            console.log(processAccess)
            if (processAccess.status == 0) {
              this.loadProcessToEdit(params['processId']);
            } else {
              console.log('in else')
              this.authAlert.validateModuleWithPermissions('LibraryProcess', params['processId'], processAccess.companyID, 'edit')
            }
          })
        }
      })

    }
    var hasEditPermission: any = false;
    if (this.currentURL.includes('edit') && !environment.PSS) {
      hasEditPermission = this.commonFunction.validateURL('Process', 'edit');

      this.activatedRoute.params.subscribe(params => {
        if (params['processId'] != undefined) {

          var data = {
            module: 'Process',
            ID: params['processId'],
            CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
          }

          this.meetingService.authonticateDataForComapnay(data).subscribe(processAccess => {
            if (processAccess.status == 0) {
              this.loadProcessToEdit(params['processId']);
            } else {
              this.authAlert.validateModuleWithPermissions('Process', params['processId'], processAccess.companyID, 'edit')
            }
          })
        }
      })

    }
    else if (!environment.PSS) {
      hasEditPermission = this.commonFunction.validateURL('Process', 'add');
    } else {
      hasEditPermission = false;
    }
    this.hasPermission = hasEditPermission;
    // this.hasPermission = this.commonFunction.validateURL('Process', 'edit');
    // this.disableControls(this.hasPermission);

    var self = this;

    $('#addedtaskTable').on('row-reorder.dt', function (e, details, edit) {
      console.log(details);
      self.orderDetails = details;
      throw 'ignore error';

      // var newvalues = [];
      // for (var i = 0; i < details.length; i++) {
      //   console.log(
      //     //'Edit',edit,
      //     'Node', details[i].node,
      //     'moved from', details[i].oldPosition,
      //     'to', details[i].newPosition

      //   );

      // self.processMasterService.reOrderRowsArraysforProcess(details, self.processId)
      //    .subscribe(process => {

      //     //this.groupTypes = groupList.groupList;
      //     //this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
      //     self.orderDetails=details;
      //   })
      //   throw 'please ignore this error';

    });

    var self = this;
    setTimeout(function () {
      let table1 = $("#companytaskTable").DataTable();
      var searchedDataForSelectAll = [];

      table1.on('search.dt', function () {
        self.searcheFilteredDataTask = [];
        var tableData = $("#companytaskTable").DataTable().column(0, { search: 'applied' }).data();
        console.log("tableData", tableData.length)
        for (var i = 0; i < tableData.length; i++) {
          self.searcheFilteredDataTask.push(tableData[i])
        }

        var value = $('.dataTables_filter input').val();
        console.log("condition", value && self.selectedAll == true);
        if (value && self.selectedAll == true) {
          self.selectedAll = false;
        }

        // var allSearchedSelected = false;
        // if (_.size(self.companytasklist)) {
        //   for (var i = 0; i < self.companytasklist.length; i++) {
        //     for (var j = 0; j < self.searcheFilteredDataTask.length; j++) {
        //       if (self.searcheFilteredDataTask[j] == self.companytasklist[i].ID) {
        //         if (self.companytasklist[i].SelectedTasks) {
        //         } else {
        //           allSearchedSelected = false;
        //         }
        //       }
        //     }
        //   }
        // }

        // if (allSearchedSelected) {
        //   console.log("if");
        //   self.selectedAll = true;
        // } else {
        //   self.selectedAll = false;
        //   console.log("else");
        // }

        // localStorage.setItem('searchdata',JSON.stringify(self.searcheFilteredDataTask));

      });
    }, 3000);

  }
  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }
  back() {
    // var fromMeeting = localStorage.getItem('fromMeeting')
    // this.router.navigate(['/meeting']);
    this.ngOnInit();
    this.location.back();
  }

  initialiseJqueryEvents() {

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    $('#processDialog').on('shown.bs.modal', function (e) {
      $('#processName').focus();
    });
  }







  reset() {
    $('#resetConfirmation').modal('toggle');
  }

  resetFormData() {
    this.processMasterForm.reset();
    $('#resetConfirmation').modal('toggle');
    this.ngOnInit();
  }


  getGroupmasterList() {
    this.groupTypes = [];
    this.groupMasterService.getGroupList()
      .subscribe((groupList: any) => {
        if (groupList.status == 0) {
          //this.groupTypes = groupList.groupList;
          this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
        }
      })
  }

  showTaskParticulars() {
    this.processMasterForm.controls.TaskParticulars.setValidators([Validators.required, this.customValidation.noWhitespaceValidator]);
    this.processMasterForm.controls.TaskParticulars.updateValueAndValidity();
    // this.taskForm.controls.ProcessID.clearValidators();
    // this.taskForm.controls.ProcessID.updateValueAndValidity();
    //$('#taskParticularsDialog').modal('toggle');
  }

  removeTaskParticularsvalidation() {
    this.processMasterForm.controls.TaskParticulars.clearValidators();
    this.processMasterForm.controls.TaskParticulars.updateValueAndValidity();
  }

  addProcess() {
    this.disabledOnclick = true;
    if (this.processMasterForm.status == "VALID") {

      var processtasks = this.predefinedCompanyTaskList;

      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var checkGlobal = true;
      if (this.processMasterForm.controls.IsGlobal.value == 'Company') {
        checkGlobal = false
      }
      var meetingTypeID = null;
      if (this.processMasterForm.controls.meetingtypeId.value != "0") {
        meetingTypeID = this.processMasterForm.controls.meetingtypeId.value;
      }
      var newProcess = {
        ProcessName: this.processMasterForm.controls.ProcessName.value,
        IsGlobal: checkGlobal,
        IsMeetingTask: this.isMeetingTask,
        MeetingTypeId: meetingTypeID,
        CreatedBy: loginUsers._id,
        processTasks: this.predefinedCompanyTaskList
      }

      this.processMasterService.addProcessandaddtasktoProcess(newProcess)
        .subscribe(process => {
          this.disabledOnclick = false;
          if (process.status == 0) {
            //$('#processDialog').modal('toggle');
            //this.alert.success(process.message);
            this.alert.successWithOk1(process.message, () => {
              this.router.navigate(
                [{ outlets: { 'structure-outlet': ['process'] } }],
                { relativeTo: this.route.parent });
            });
          }
          else {
            //$('#processDialog').modal('toggle');
            // this.alert.error(process.message);
            if (process.err_fields != undefined) {
              this.alert.error(JSON.stringify(process.err_fields) + ' fields are required or invalid.');
            } else {
              this.alert.error(process.message);
            }
          }

          //this.getProcessList();
          //this.processMasterForm.reset();
        });

    } else {
      console.log('Invalid form submit.')
      return false;
    }
  }

  getMeetingNameById() {
    $("#meetingTypeName").val('');
    $("#meetingTypeIdWhileEdit").val('');
    setTimeout(() => {
      if (this.meetingTypeName) {
        $("#meetingTypeName").val(this.meetingTypeName);
        $('#meetingTypeIdWhileEdit').val(this.meetingTypeIdWhileEdit);
      }
      $('#meetingTypeName').prop("disabled", true);
    }, 300);
  }

  changeIsGlobal(value) {
    if (value == 'Global') {
      this.isGlobalSelected = true;
    } else {
      this.isGlobalSelected = false;
    }
  }

  loadProcessToEdit(processId) {
    this.processMasterService.getProcessById(processId)
      .subscribe(process => {
        if (process.status == 0) {
          //$('#processDialog').modal('toggle') //
          this.processId = process.processData[0]._id;
          $('#IsGlobalYes').prop("disabled", true);
          $('#IsGlobalNo').prop("disabled", true);
          if (process.processData[0].IsPredefined) {
            // $('#IsGlobalYes').prop("disabled", true);
            // $('#IsGlobalNo').prop("disabled", true);
            $('#meetingTypeName').prop("disabled", true);
            $('#IsMeetingSpecific').prop('disabled', true);
            this.disableOnEdit = true;
          }

          if (process.processData[0].IsGlobal) {
            this.processMasterForm.controls.IsGlobal.setValue('Global');
            // $('#IsGlobalYes').prop("disabled", true);
            // $('#IsGlobalNo').prop("disabled", true);
            $('#meetingTypeName').prop("disabled", true);
            $('#IsMeetingSpecific').prop('disabled', true);
            this.disableOnEdit = true;
          }
          else {
            this.processMasterForm.controls.IsGlobal.setValue('Company');
          }
          this.processMasterForm.controls.ProcessName.setValue(process.processData[0].ProcessName);
          if (process.processData[0].meetingType_master) {
            this.meetingTypeName = process.processData[0].meetingType_master.MeetingType;
            this.meetingTypeIdWhileEdit = process.processData[0].meetingType_master._id;
          } this.getMeetingNameById();

          this.processCompanyId = process.processData[0].CompanyId;

          this.PageTitle = process.processData[0].ProcessName;
          $("#myModalLabel").html('Process:' + this.PageTitle);

          if (process.processData[0].IsMeetingTask) {
            //this.processMasterForm.controls.ProcessName.setValue(process.processData[0].ProcessName);
            this.isMeetingTask = process.processData[0].IsMeetingTask;
            this.meetingtypeIdmodel = process.processData[0].MeetingTypeId;
          }
          else {
            this.isMeetingTask = process.processData[0].IsMeetingTask;
            this.meetingtypeIdmodel = "0";
          }
        }
      });
  }


  processTasksSaveOrder() {
    this.disabledOnclick = true;
    this.processMasterService.reOrderRowsArraysforProcess(this.orderDetails, this.processId).subscribe(data => {
      this.disabledOnclick = false;
      if (data.status == 0) {
        this.alert.success("Order of the tasks saved successfully.");
        this.showProcessTasks(this.processId);
      }
    });
  }

  showTaskParticularsDialogue() {

    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#taskParticularsDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#taskParticularsDialog').modal('show');
    }, 100);
  }

  saveandactivateProcess() {
    this.disabledOnclick = true;
    if (this.processMasterForm.status == "VALID" && this.processMasterForm.controls.TaskParticulars.value) {

      var processtasks = this.predefinedCompanyTaskList;

      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var checkGlobal = true;
      if (this.processMasterForm.controls.IsGlobal.value == 'Company') {
        checkGlobal = false
      }
      var meetingTypeID = null;
      if (this.processMasterForm.controls.meetingtypeId.value != "0") {
        meetingTypeID = this.processMasterForm.controls.meetingtypeId.value;
      }
      var newProcess = {
        ProcessName: this.processMasterForm.controls.ProcessName.value,
        IsGlobal: checkGlobal,
        IsMeetingTask: this.isMeetingTask,
        MeetingTypeId: meetingTypeID,
        CreatedBy: loginUsers._id,
        processTasks: this.predefinedCompanyTaskList,
        TaskParticulars: this.processMasterForm.controls.TaskParticulars.value
      }

      this.processMasterService.addProcessandactivateProcess(newProcess)
        .subscribe(process => {
          this.disabledOnclick = false;
          if (process.status == 0) {
            // Properly clean up modal and backdrop before navigation
            $('#taskParticularsDialog').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            $('#taskParticularsDialog').modal('hide');
            //this.alert.success(process.message);
            this.alert.successWithOk1(process.message, () => {
              this.router.navigate(
                [{ outlets: { 'structure-outlet': ['activatedprocess'] } }],
                { relativeTo: this.route.parent });
            });
          }
          else {
            // this.alert.error(process.message);
            if (process.err_fields != undefined && process.err_fields != "") {
              // Properly clean up modal and backdrop before navigation
              $('#taskParticularsDialog').off('hidden.bs.modal');
              $('.modal-backdrop').remove();
              $('body').removeClass('modal-open');
              $('#taskParticularsDialog').modal('hide');
              this.alert.error1(JSON.stringify(process.err_fields) + ' fields are required or invalid.', () => { });
            } else {
              // Properly clean up modal and backdrop before navigation
              $('#taskParticularsDialog').off('hidden.bs.modal');
              $('.modal-backdrop').remove();
              $('body').removeClass('modal-open');
              $('#taskParticularsDialog').modal('hide');
              this.alert.error1(process.message, () => {
              });
            }
          }

        });

    } else {
      console.log('Invalid form submit.')
      return false;
    }
  }

  updateandactivateProcess() {
    this.disabledOnclick = true;
    if (this.processMasterForm.status == "VALID" && this.processMasterForm.controls.TaskParticulars.value) {

      var activateprocesstasks = this.predefinedCompanyTaskList;
      console.log("activateprocesstasks-->" + activateprocesstasks);
      var processtasks = _.remove(this.predefinedCompanyTaskList, {
        _id: null
      });

      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var checkGlobal = true;
      if (this.processMasterForm.controls.IsGlobal.value == 'Company') {
        checkGlobal = false
      }
      var meetingTypeID = null;
      if (this.processMasterForm.controls.meetingtypeId.value != '0' && this.processMasterForm.controls.meetingtypeId.value != undefined && this.processMasterForm.controls.meetingtypeId.value != '') {
        meetingTypeID = this.processMasterForm.controls.meetingtypeId.value;
      }
      else if ($('#meetingTypeIdWhileEdit').val() != undefined && $('#meetingTypeIdWhileEdit').val() != "") {
        meetingTypeID = $('#meetingTypeIdWhileEdit').val();
      }

      var updatedProcess = {
        ProcessId: this.processId,
        ProcessName: this.processMasterForm.controls.ProcessName.value,
        IsGlobal: checkGlobal,
        IsMeetingTask: this.isMeetingTask,
        MeetingTypeId: meetingTypeID,
        ModifiedBy: loginUsers._id,
        processTasks: processtasks,
        activateprocesstasks: activateprocesstasks,
        TaskParticulars: this.processMasterForm.controls.TaskParticulars.value
      }

      this.processMasterService.updateProcessandactivateProcess(updatedProcess)
        .subscribe(process => {
          this.disabledOnclick = false;
          if (process.status == 0) {
            // Properly clean up modal and backdrop before navigation
            $('#taskParticularsDialog').modal('hide');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            //this.alert.success(process.message);
            this.alert.successWithOk1(process.message, () => {
              this.router.navigate(
                [{ outlets: { 'structure-outlet': ['activatedprocess'] } }],
                { relativeTo: this.route.parent });
            });
          }
          else {
            $('#taskParticularsDialog').modal('toggle');
            this.alert.error(process.message);
          }

        });

    } else {
      console.log('Invalid form submit.')
      return false;
    }
  }


  showProcessTasks(processId) {

    var table1 = $('#addedtaskTable').DataTable({ destroy: true });
    table1.destroy();

    this.processtasklist = [];

    this.taskService.getCompanyProcessTaskListByProcessID(processId)
      .subscribe(taskList => {
        if (taskList.status == 0) {

          //this.predefinedCompanyTaskList = taskList.processTasksDatalist.TasksData;

          this.predefinedCompanyTaskList = this.commonFunction.sortByasc(taskList.processTasksDatalist.TasksData, 'Order');

          var taskdatacount = this.predefinedCompanyTaskList.length;
          if (taskdatacount > 0) {
            this.taskaddedforactivateProcess = true;
          }
          else {
            this.taskaddedforactivateProcess = false;
          }
          // console.log("this.predefinedCompanyTaskList" + this.predefinedCompanyTaskList);
          this.dtTriggerForAddedTask.next();
        }
      })

    // var self = this;

    // this.dtOptionsForAddedTask = {
    //   // pagingType: 'full_numbers',
    //   serverSide: true,
    //   processing: true,
    //   ajax: (dataTablesParameters: any, callback) => {
    //     self.taskService.getCompanyProcessTaskListByProcessID(processId)
    //       .subscribe(taskList => {
    //         if (taskList.status == 0) {
    //           self.predefinedCompanyTaskList = taskList.processTasksDatalist.TasksData;
    //           console.log("prtasks" + self.predefinedCompanyTaskList);

    //           var taskdatacount = this.predefinedCompanyTaskList.length;
    //           if (taskdatacount > 0) {
    //             this.taskaddedforactivateProcess = true;
    //           }
    //           else {
    //             this.taskaddedforactivateProcess = false;
    //           }

    //           callback({
    //             recordsTotal: taskList.processTasksDatalist.TasksData.length,
    //             recordsFiltered: 10,
    //             data: [],
    //           });
    //         }
    //       });
    //   },
    //   columns: [
    //     { data: "OrderID" },
    //     { data: "TaskName" },
    //     { data: "TaskDescription" },
    //     { data: "GroupName" }
    //     // { data: "_id" },
    //     // { data: "ID" },
    //   ],
    // };


  }



  editProcess() {
    this.disabledOnclick = true;
    if (this.processMasterForm.status == "VALID") {

      var processtasks = _.remove(this.predefinedCompanyTaskList, {
        _id: null
      });

      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var checkGlobal = true;
      if (this.processMasterForm.controls.IsGlobal.value == 'Company') {
        checkGlobal = false
      }
      var meetingTypeID = null;
      if (this.processMasterForm.controls.meetingtypeId.value != '0' && this.processMasterForm.controls.meetingtypeId.value != undefined && this.processMasterForm.controls.meetingtypeId.value != '') {
        meetingTypeID = this.processMasterForm.controls.meetingtypeId.value;
      }
      else if ($('#meetingTypeIdWhileEdit').val() != undefined && $('#meetingTypeIdWhileEdit').val() != "") {
        meetingTypeID = $('#meetingTypeIdWhileEdit').val();
      }
      var updatedProcess = {
        ProcessId: this.processId,
        ProcessName: this.processMasterForm.controls.ProcessName.value,
        IsGlobal: checkGlobal,
        IsMeetingTask: this.isMeetingTask,
        MeetingTypeId: meetingTypeID,
        ModifiedBy: loginUsers._id,
        processTasks: processtasks
      }
      this.processMasterService.updateProcessandaddtasktoProcess(updatedProcess)
        .subscribe(process => {
          this.disabledOnclick = false;
          if (process.status == 0) {
            this.alert.successWithOk1(process.message, () => {
              this.router.navigate(
                [{ outlets: { 'structure-outlet': ['process'] } }],
                { relativeTo: this.route.parent });
            });

          }
          else {
            this.alert.error(process.message);
          }

        });
    }
    else {
      return false;
    }
  }


  getMeetingTypeList() {
    this.meetingTypes = [];
    this.processMasterService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        if (meetingTypeList.status == 0) {
          //this.meetingTypes = meetingTypeList.meetingTypeList;
          this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, 'MeetingType');
        }
      })
  }

  regiserModalShowEvent() {

    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#AddCompliancesDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#AddCompliancesDialog').modal('show');
    }, 100);

    $('#AddCompliancesDialog').on('shown.bs.modal', function (e) {
      $('#companytaskTable').DataTable().columns.adjust();
    })

  }

  getpredefinedTaskList() {
    this.preDefinedTask = [];
    this.taskService.getCompanyTaskList().subscribe(tasklist => {
      if (tasklist.status == 0) {

        //console.log("tasklist.taskList"+tasklist.taskList);
        // var predefinedTaskList = $(tasklist.taskList).filter(function (i, n) { return n.TriggerType==1 });
        var predefinedTaskList = _.filter(tasklist.taskList, function (o) {
          return o.TriggerType == 1;
        });
        //this.processes = this.commonFunction.sortByKey(processData, 'ProcessName');

        this.preDefinedTasknew = predefinedTaskList;
        // console.log('( this.preDefinedTaskNew)', this.preDefinedTasknew);
        // console.log('( this.preDefinedTask)', this.preDefinedTask);
        var removingKeyArr = [];
        if (this.preDefinedTask.length > 0) {
          var newtsk = [];
          newtsk = this.preDefinedTasknew;
          for (var key in this.preDefinedTasknew) {
            for (var key2 in this.preDefinedTask) {
              if (this.preDefinedTasknew[key].TaskName == this.preDefinedTask[key2].TaskName) {
                removingKeyArr = removingKeyArr.concat(key);
                newtsk.splice(parseInt(key), 1);
              }
            }//second For Loop
          }//first for loop
          this.preDefinedTasknew = newtsk;
        }//if-->checking available task for edit to remove duplicates
      }//if-->checking status of api
    })
  }

  getCompanyTaskList() {
    var table2 = $('#companytaskTable').DataTable({ destroy: true });
    table2.destroy();
    this.companytasklist = [];
    var companytaskWithAddedToShow = []
    var unique = []

    this.taskService.getCompanyTaskList()
      .subscribe(taskList => {

        var predefinedCompanyTasks = _.filter(taskList.tasksDatalist.TasksData, function (o) {
          return o.TriggerType == 1;
        });

        //var predefinedTaskList = $(taskList.tasksDatalist.TasksData).filter(function (i, n) { return n.TriggerType!=2 });
        //this.companytasklist = taskList.tasksDatalist.TasksData;
        this.companytasklist = predefinedCompanyTasks;
        //console.log("this.predefinedCompanyTaskList"+this.predefinedCompanyTaskList);
        for (var j = 0; j < (this.predefinedCompanyTaskList != undefined ? this.predefinedCompanyTaskList.length : 0); j++) {
          var index = this.indexOfElementArray(this.companytasklist, this.predefinedCompanyTaskList[j]);
          // console.log(index);
          this.companytasklist.splice(index, 1);
        }
        //console.log("this.companytasklist.length--->"+this.companytasklist.length);
        //this.companytasklist = unique;
        // console.log(unique);
        this.dtTriggerTaskAddingPopup.next();
      });
  }

  indexOfElementArray(array: any[], elementValue) {
    var index = _.findIndex(array, function (o) {
      //console.log("o.TaskID"+o.ID, "elementValue.TaskID"+elementValue._id) ;
      if (o.TaskID == elementValue.TaskID) {
        // console.log('found element', o);
      }
      return o.TaskID == elementValue.TaskID;
    })
    return index;
  }

  companyTaskListBySearchFilter(searchParameters) {

    this.companytasklist = [];
    var searchedData = [];
    var companytaskWithoutAgendaTaskList = []
    this.taskService.getCompanyTaskListBySearchFilters(searchParameters)
      .subscribe(taskList => {
        if (taskList.status == 0) {

          //remove alredy existing data

          if (this.predefinedCompanyTaskList) {
            //On Update show nont available Task from agenda in search filter  this.agendaAddedTaskList 
            //searchedData = taskList.tasksDatalist.TasksData;
            //var searchedPredefinedTaskList = $(taskList.tasksDatalist.TasksData).filter(function (i, n) { return n.TriggerType==1 });

            var searchedPredefinedTaskList = _.filter(taskList.tasksDatalist.TasksData, function (o) {
              return o.TriggerType == 1;
            });

            searchedData = searchedPredefinedTaskList;
            var k = 0;
            for (var i = 0; i < searchedData.length; i++) {
              var flag = true;
              for (var j = 0; j < this.predefinedCompanyTaskList.length; j++) {

                if (searchedData[i].ID == this.predefinedCompanyTaskList[j].Task_id) {
                  flag = false;
                  break;
                } else {
                }
              }
              if (flag) {
                companytaskWithoutAgendaTaskList.push(searchedData[i]);
              }
            }
            searchedData = companytaskWithoutAgendaTaskList;

            this.companytasklist = searchedData;
          } else {
            // console.log(taskList);
            this.companytasklist = taskList.tasksDatalist.TasksData;
          }
          this.dtTriggerTaskAddingPopup.next();
        }
      })
  }

  addTasksToProcess() {

    var table1 = $('#addedtaskTable').DataTable({ destroy: true });
    table1.destroy();

    var table2 = $('#companytaskTable').DataTable({ destroy: true });
    table2.destroy();


    var addedFullData = this.companytasklist.filter(opt => opt.SelectedTasks).map(opt => opt);

    console.log("addedFullData" + addedFullData);

    var nonAdded = this.companytasklist;
    this.companytasklist = []
    var j = 0;
    for (var i = 0; i < nonAdded.length; i++) {
      if (nonAdded[i].SelectedTasks == true) {
        // console.log(nonAdded[i]);
      } else {
        this.companytasklist[j] = nonAdded[i];
        j++;
      }
    }
    this.dtTriggerTaskAddingPopup.next()
    // console.log('addedFullData',addedFullData);
    var storingDataToAgenda = [];
    var existingDataOfAgenda = this.ActualDataToProcess
    var i = 0;

    addedFullData.forEach(element => {

      // console.log("element"+element.TaskName);

      storingDataToAgenda[i] = {
        _id: null,
        Task_id: element.ID,
        TaskID: element.TaskID,
        TaskName: element.TaskName,
        TaskDescription: element.TaskDescription,
        GroupID: element.GroupID,
        GroupName: element.GroupName,
        IsGlobal: element.IsGlobal
      }
      i++;
    });


    if (this.predefinedCompanyTaskList) {
      this.predefinedCompanyTaskList = this.predefinedCompanyTaskList.concat(storingDataToAgenda);
    }
    else if (existingDataOfAgenda) {
      this.predefinedCompanyTaskList = existingDataOfAgenda.concat(storingDataToAgenda);
    }
    else {
      this.predefinedCompanyTaskList = storingDataToAgenda;
    }

    var datacount = this.predefinedCompanyTaskList.length;
    if (datacount > 0) {
      this.dataAdd = true;
      this.taskaddedforactivateProcess = true;
    }
    else {
      this.dataAdd = false;
      this.taskaddedforactivateProcess = false;
    }

    this.dtTriggerForAddedTask.next();
    // console.log(this.agendaAddedTaskList);
    ////inside popup form dialog
    $('#AddCompliancesDialog').off('hidden.bs.modal');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#AddCompliancesDialog').modal('hide');


  }

  deleteConfirmation(processTaskId, isGlobal) {
    var localStorageCompanyId = JSON.parse(localStorage.getItem("companyDetails")).companyID;
    console.log('localStorageCompanyId ' + localStorageCompanyId + ' this.processCompanyId: ' + this.processCompanyId + ' isGlobal' + isGlobal);
    // *** Global task selected in any PROCESS of one company should not be allowed for deleting from any company ***
    if (localStorageCompanyId != this.processCompanyId && isGlobal) {
      $('#warningModal').modal('toggle');
    } else {
      this.processTaskId = processTaskId;
      this.isTaskGlobal = isGlobal;
      $('#confirmation').modal('toggle');
    }
  }


  deleteTaskProcess() {
    this.taskService.deleteTaskfromProcess(this.processTaskId).subscribe((data: any) => {
      if (data.status == 0) {
        $('#confirmation').modal('toggle');
        this.alert.success(data.message);
        this.showProcessTasks(this.processId);


      }
      else {
        $('#confirmation').modal('toggle');
        this.alert.error(data.message);
      }
    });
  }

  removeTaskFromList(deletingTask_id) {
    var table = $('#addedtaskTable').DataTable({ destroy: true });
    table.destroy();
    console.log(deletingTask_id);
    console.log(this.predefinedCompanyTaskList);
    for (var i = 0; i < this.predefinedCompanyTaskList.length; i++) {
      var cur = this.predefinedCompanyTaskList[i];
      if (cur.Task_id == deletingTask_id) {
        this.predefinedCompanyTaskList.splice(i, 1);
        break;
      }
    }
    var datacount = this.predefinedCompanyTaskList.length;
    if (datacount > 0) {
      this.dataAdd = true;
    }
    else {
      this.dataAdd = false;
    }
    this.dtTriggerForAddedTask.next()

    this.getCompanyTaskList()
    console.log(this.predefinedCompanyTaskList);
  }

  refreshTaskList() {
    if (this.currentURL.includes('edit')) {
      var table = $('#companytaskTable').DataTable({ destroy: true });
      table.destroy();
      this.getCompanyTaskList();
    } else {
      var table = $('#companytaskTable').DataTable({ destroy: true });

      table.destroy();
      this.getCompanyTaskList();
    }
    $("#groupdropdown").val("null");

    this.groupID = null;
    this.selectedAll = false;
    this.SearchtaskEventbasedorPeriodicModel = null;
    this.SearchtaskUserdefinedorPredefinedModel = null;
  }


  getSelectedGroupID(ev) {
    var id = ev.target.value;
    this.groupID = id;
  }

  showTasksBySearchData() {
    var searchParameters = {
      //EventBasedorPeriodic: this.SearchtaskEventbasedorPeriodicModel,
      EventBasedorPeriodic: 1,
      UserdefinedorPredefined: this.SearchtaskUserdefinedorPredefinedModel,
      GroupId: this.groupID
    };

    //console.log("searchParameters"+searchParameters.EventBasedorPeriodic);

    if (searchParameters.EventBasedorPeriodic != undefined || searchParameters.GroupId != undefined || searchParameters.UserdefinedorPredefined != undefined) {
      var table = $('#companytaskTable').DataTable({ destroy: true });
      table.destroy();
      this.companyTaskListBySearchFilter(searchParameters);
    }
    // console.log(searchParameters);
  }

  EditTask(taskId) {
    console.log(taskId)
    localStorage.setItem('redirectfromLibraryProcess', this.processId);
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['updateTask', taskId] } }],
      { relativeTo: this.route.parent });

    // this.router.navigate(['/tasks/library/update/', taskId]);
  }


  checkAllIfselectAll() {
    for (var i = 0; i < this.companytasklist.length; i++) {
      for (var j = 0; j < this.searcheFilteredDataTask.length; j++) {
        if (this.searcheFilteredDataTask[j] == this.companytasklist[i].ID) {

          this.companytasklist[i].SelectedTasks = this.selectedAll;
          this.IsSelectedTasks = this.selectedAll;
        }
      }
    }
  }

  checkIfAllSelected() {
    this.selectedAll = this.companytasklist.every(function (item: any) {
      return item.SelectedTask == true;

    })
  }

  checkselected(ev) {
    if (ev.target.checked == true) {
      this.IsSelectedTasks = true;
    }
    else {
      this.IsSelectedTasks = false;
    }

    var allSearchedSelected = true;
    if (_.size(this.companytasklist)) {
      for (var i = 0; i < this.companytasklist.length; i++) {
        for (var j = 0; j < this.searcheFilteredDataTask.length; j++) {
          if (this.searcheFilteredDataTask[j] == this.companytasklist[i].ID) {
            if (this.companytasklist[i].SelectedTasks) {
            } else {
              allSearchedSelected = false;
            }
          }
        }
      }
    }
    if (allSearchedSelected) {
      this.selectedAll = true;
    } else {
      this.selectedAll = false;
    }


  }

  getSelectedTaskList(taskList) {
    var Arr = [];
    var newArr = [];
    Arr = taskList.split(',');
    //  console.log('taskList','--->'+taskList+'<----');
    if (taskList != "") {
      for (var i = 0; i < Arr.length; i++) {
        var element = Arr[i];
        newArr = newArr.concat({ TaskName: element });
      }
      this.preDefinedTask = newArr;
    }
  }

  disableControls(editPermission: boolean) {
    if (!editPermission && environment.PSS == false) {
      this.processMasterForm.controls.ProcessName.disable();
      this.processMasterForm.controls.IsGlobal.disable();
      this.processMasterForm.controls.meetingtypeId.disable();
      this.processMasterForm.controls.TaskParticulars.disable();
    }
  }

}
